import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg, { NO_TRANSITION_CLASSNAME } from '../Svg';

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5858 1.59033L2.7002 4.39114V9.657H12.363V4.39114L7.5858 1.59033Z",
  fill: "white",
  className: NO_TRANSITION_CLASSNAME
});

var EqualHousing = function EqualHousing(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#4C5165' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.5rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Equal Housing icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 15 11",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.22329L7.58579 0L15 4.26747V5.75181H13.817V11H1.16496V5.75181H0V4.22329Z",
    fill: color
  }), _ref2, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98499 6.39669V5.0979H10.0422V6.39669H4.98499Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98499 7.03296H10.0422V8.33175H4.98499V7.03296Z",
    fill: color
  }));
};

export default EqualHousing;